import Component from "vue-class-component"

import { SearchFeatured } from "@skinsoft/types"
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { LocalizedString } from "@skinsoft/ui"
import { Media } from "@skinsoft/ui/src/item-card/media"

require('./simple-item-featured-card.scss')

@Component({
    components: {
        sMedia: Media,
        sLocalizedString: LocalizedString
    },
    props: ['searchFeatured'],
    template: require("./simple-item-featured-card.html")
})
export class SimpleItemFeaturedCard extends ReactiveVue {
    searchFeatured: SearchFeatured

    private getReadableCardType(cardType: string, defaultCardTypeKey: string = 'museum') {
        const cardTypeKeyMatcher = /^.+?([A-Z][a-z]+)/;
        const cardTypeMatchResult = cardType.match(cardTypeKeyMatcher)
        const typeId = cardTypeMatchResult && cardTypeMatchResult.length > 1 ? cardTypeMatchResult[1].toLowerCase() : defaultCardTypeKey
        return this.$t(`entity.itemTypes.${typeId}`)
    }
}